import { createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { isRuleFilterActive } from '@cbridge-tools/rules-data-grid-filter';
import {
  rulesValidityFilterSelector,
  rulesValidityFilterHasItemsSelector,
} from '@cbridge-modules/rules-management-page';

export const externalReportingLayoutPropsSelector = createCachedSelector(
  [
    rulesValidityFilterSelector,
    rulesValidityFilterHasItemsSelector,
  ],
  (validityFilter, hasInvalidRules) => ({
    hasInvalidRules,
    hasActiveFilters: isRuleFilterActive(validityFilter),
  }),
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
